import * as css from './crowdSearch.css';
import Table from '../../../component/newTable/Table';
import Btn from '../../../component/button/btn/Btn';
import {useRef, useMemo} from 'react';
import {LIGHT_SHADOW_COLOR, WHITE, YELLOW} from '../../../globalVariables/GlobalVariables';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import NoResultsIcon from '../../../assets/icons/noResults';
import SearchWithStarts from '../../../assets/icons/searchWithStarts';
import CustomScrollbar from '../../../component/customScrollbar/CustomScrollbar';
import Loader from '../../../component/loader/Loader';
import {highlightText} from '../../../functions/highlightText';
import {iframeClick} from '../../../components/RouteComponent/RouteComponent';

export function resultRow({member, crowdName, searchText, crid,close}: {member: any, crowdName: string, searchText: string; crid: number,close: () => void}){
    const {t} = useTranslation('crowd');
    const show=()=> {
        iframeClick('showCrowdMember',null, {cmid: member.cmid, crid});
        close();
    };
    const regex = useMemo(() => new RegExp(`(${searchText})`, 'gi'), [searchText]);

    return (
        <css.row>
            <css.cell>
                <css.logo />
            </css.cell>
            <css.contentCell>
                {Object.entries(member).map((entry: any, index)=>(entry[0]!=='cmid' && <>
                    <css.cell key={index}>
                        {highlightText(entry[1], css.boldText, null, regex)}{'   '}({t(entry[0])})
                    </css.cell>
                </>))}
                <css.cell>{t('crowd')} {crowdName}</css.cell>
                {/* <css.placeholderCell/> */}
            </css.contentCell>
            <css.cell>
                <Btn style={`background-color: ${WHITE};`} onClick={show} >{t('show')}</Btn>
            </css.cell>
        </css.row>
    );
}

export function NoResults(){
    const {t} = useTranslation('crowd');

    return (
        <css.noResultContainer>
            <NoResultsIcon />
            <css.noResultTitle>{t('noResultsTitle')}</css.noResultTitle>
            <css.noResultText>{t('noResultsText')}</css.noResultText>
        </css.noResultContainer>
    );
}

export function StartsSearch({setFocus}: {setFocus: () => void}){
    const {t} = useTranslation('crowd');

    return (
        <css.noResultContainer>
            <SearchWithStarts />
            <css.noResultText>{t('startSearchText')}</css.noResultText>
            <Btn style={`background-color: ${YELLOW}; border: none; box-shadow: 2px 4px 4px 0px ${LIGHT_SHADOW_COLOR}`} onClick={setFocus} >{t('startSearch')}</Btn>
        </css.noResultContainer>
    );
}

export function SearchResult({searchText, loadMore,close}: {loadMore: () => void, searchText: string,close: () => void}){
    const {t} = useTranslation('crowd');
    const {searchResults=[], searchCrowdsXHR} = useSelector((state: any) => (state.crowds));

    const membersCount = useMemo(()=>searchResults.reduce((acc, table) => acc+=table.members.length,0), [searchResults]);

    const containerRef = useRef();

    const cssStyle = 'inset-inline-end: -24px;';

    return (<>
        {membersCount ? <css.resultTitle>
            {t('membersCount', {count: membersCount})}
        </css.resultTitle>:<></>}
        <CustomScrollbar contentRef={containerRef} cssStyle={cssStyle}/>
        <Loader height={'calc(100% - 55px)'} XHR={searchCrowdsXHR} onScrollEnd={loadMore} containerRef={containerRef}>
            {searchResults.map(table=>(table.members?.length? <div key={table.crowdId}>
                <css.crowdName> {table.title}
                    <css.linkText onClick={()=> {
                        iframeClick('showCrowd', null, {crid: table.crowdId, searchText});
                        close();
                    }}>{t('showCrowd')}</css.linkText>
                </css.crowdName>
                <Table list={table.members.map((row) => (
                    {
                        comp: resultRow,
                        props: {member: row, crowdName: table.title, searchText, crid: table.crowdId,close},
                        key: row.id
                    })
                )}
                checked={undefined} buttonsChildren={undefined} searchProps={undefined}  />
            </div> : <></>))}
        </Loader>
    </>);
}
